export default "__VITE_ASSET__9146ae8e__"